import React from 'react';
import { Icon } from './Icon.js';
export const IconPetClinic = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 10L20 8H14L14 2H8L7.99998 8H2L2.00002 14H8V20H10", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M18 22C20.2091 22 22 20.3034 22 18.2105L21.5 14L21 14L19 16H17L15 14H14.5L14 18.2105C14 20.3034 15.7909 22 18 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPetClinic.js.map